import bilheteIcon from '@/assets/prize-games/bilhete.png';
import caixinhaIcon from '@/assets/prize-games/caixa/caixa-premiada.png';
import roletaIcon from '@/assets/prize-games/roleta/roullete_icon.png';
import raspadinhaIcon from '@/assets/prize-games/raspadinha/raspdinha-site.png';

export const PRIZE_GAME_LABELS = {
  cota: 'Bilhete Premiado',
  caixinha: 'Caixinha Premiada',
  roleta: 'Roleta Premiada',
  raspadinha: 'Raspadinha Premiada',
};

export const PRIZE_GAME_ICONS = {
  cota: bilheteIcon,
  caixinha: caixinhaIcon,
  roleta: roletaIcon,
  raspadinha: raspadinhaIcon,
};

export function normalizePrizeGameKind(variant) {
  // Backend / painel usam "caixa"; UI unificada usa "caixinha".
  if (variant === 'caixinha' || variant === 'caixa' || variant === 'game') {
    return 'caixinha';
  }
  if (variant === 'roleta') return 'roleta';
  if (variant === 'raspadinha') return 'raspadinha';
  return 'cota';
}

export function prizeGameIcon(variant) {
  return PRIZE_GAME_ICONS[normalizePrizeGameKind(variant)];
}

export function prizeGameLabel(variant) {
  return PRIZE_GAME_LABELS[normalizePrizeGameKind(variant)];
}

export function prizeGameDialogTitle(variant) {
  return prizeGameLabel(variant);
}

export function prizeGameNumbersButtonLabel(variant) {
  return `Números — ${prizeGameLabel(variant)}`;
}

export function prizeGameAddButtonLabel(variant) {
  const kind = normalizePrizeGameKind(variant);
  if (kind === 'cota') return 'Adicionar bilhete premiado';
  return `Adicionar número — ${prizeGameLabel(variant)}`;
}

export function prizeGameEmptyLabel(variant) {
  const label = prizeGameLabel(variant);
  const kind = normalizePrizeGameKind(variant);
  if (kind === 'cota') return 'Nenhum bilhete premiado foi adicionado...';
  return `Nenhum número da ${label} foi adicionado...`;
}

export function prizeGameDialogHint(variant) {
  const kind = normalizePrizeGameKind(variant);
  if (kind !== 'cota') {
    return `Cadastre os números + prêmios específicos da ${prizeGameLabel(variant)}. Esta lista é independente do Bilhete Premiado.`;
  }
  return 'Cadastre os bilhetes premiados da campanha. Caixinha, Roleta e Raspadinha Premiada têm cadastros separados.';
}
